function sortNumber(a, b) {
  return a - b;
}
$(document).on("turbolinks:load",function(){
	$("#function_10_1").each(function(form) {
		var that = this;
		var counter = 0;

		// preventivamente se una selzione è già presente
		if((jsel = $(this).find('table td.day.selected')).length > 0)
		{	counter = 2;
			sel1 = jsel[0];
			sel2 = jsel[1];
			f_day = $(sel1).data('mday');
			fmonth = $(sel1).data('month');
			l_day = $(sel2).data('mday');
			var ary = [f_day,l_day].sort(sortNumber);
			$(that).find('table td.day').not('.un_selectable').each(function() {
				if($(this).data('month') == fmonth && $(this).data('mday') > ary[0] && $(this).data('mday') < ary[1])
				{	$(this).addClass('selected freeze');
				}
			});
			$(that).find("table td.day").not("[data-month='" + fmonth + "']").addClass('un_selectable').removeClass('day'); 
		}

		$(this).find('table td').click(function(){
			if($(this).hasClass('freeze'))
			{	counter = 0;
				$(that).find('input.selectable_day[type=hidden]').val(false);
				$(that).find("table td.un_selectable").removeClass('un_selectable').addClass('day');
				$(that).find("table td.selected").removeClass('selected freeze');  
				return;
			}
			if($(this).hasClass('day') && !$(this).hasClass('freeze') && !$(this).hasClass('un_selectable'))
			{	$(this).toggleClass('selected');
				selected = $(this).hasClass('selected');
				month = $(this).data('month');
				$(this).find('input.selectable_day[type=hidden]').val(selected);
				if(selected)
				{	counter++;
					if(counter == 3)
					{	counter = 0;
						$(that).find('input.selectable_day[type=hidden]').val(false);
						$(that).find("table td.un_selectable").removeClass('un_selectable').addClass('day');
						$(that).find("table td.selected").removeClass('selected freeze');  
						return;
					}
					$(that).find("table td.day").not("[data-month='" + month + "']").addClass('un_selectable').removeClass('day'); 
				}
				else
				{	counter--;
					if(counter == 0)
					{	$(that).find("table td.un_selectable").removeClass('un_selectable').addClass('day'); 	
					}
				}
				if(counter == 2)
				{	last_selected_day = $(this).data('mday');
					prev_selected = $(that).find('table td.day.selected').not($(this));
					prev_selected_day = $(prev_selected).data('mday');
					var ary = [last_selected_day,prev_selected_day].sort(sortNumber);
					$(that).find('table td.day').not('.un_selectable').each(function() {
						if($(this).data('mday') > ary[0] && $(this).data('mday') < ary[1])
						{	$(this).addClass('selected freeze');
						}
					});
				}
				else	if(counter == 1)
						{	prev_selected = $(that).find('table td.day.selected').not($(this));
							prev_selected_day = $(prev_selected).data('mday');
							if(prev_selected_day != undefined)
							{	$(that).find('table td.day').not('.un_selectable').each(function() {
									if( $(this).find('input.selectable_day[type=hidden]').val() != 'true') 	
									{	$(this).removeClass('selected freeze');
									}
								});
							}
						}
			}
		});
	}); 
});